import React from 'react';
import PropTypes from 'prop-types';
import {Modal} from '@learningblocks/storybook-components';
import {Heading} from './Heading';
import {Content} from './Content';
import {Player} from './Player';
import {PowerSupplyContext} from '..';
import {DoneButton} from './DoneButton';

import './style.scss';

export function ModalWindow(props) {
  const {running} = React.useContext(PowerSupplyContext);
  return (
    <Modal
      className='ps_modal'
      isOpen={props.modalOpen}
      close={props.toggleModal}
      size={'sim'}
      closeButton={true}>
      <Heading />
      {!running && (
        <Content
          interactionProps={props.interactionProps}
          alert={props.alert}
          togglePower={props.togglePower}
          settingsData={props.settingsData}
          setTimer={props.setTimer}
          setVoltage={props.setVoltage}
          setCurrent={props.setCurrent}
          cablesData={props.cablesData}
          onClickStart={props.onClickStart}
          onClickStop={props.onClickStop}
          pluggedIn={props.pluggedIn}
        />
      )}
      <Player player={props.player} />
      <DoneButton className='ps_modal_doneButton' onClick={props.toggleModal} />
    </Modal>
  );
}

ModalWindow.propTypes = {
  /**
   * specifies if modal window is open
   */
  modalOpen: PropTypes.bool,
  /**
   * callback function to trigger modal window open and close
   */
  toggleModal: PropTypes.func,

  ...Content.propTypes,
  /**
   * contains player component to play animation on start
   */
  player: PropTypes.element,
};
ModalWindow.defaulProps = {
  running: false,
};
